var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSpeechTail = function SvgSpeechTail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7 3c-1.875-3-6-1.798-6-.887V18l17.5-2s-.5-2-6-5C9.991 8.255 7.884 4.415 7 3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D8D8D8",
    d: "M15 12c-3.241.185-7-8.688-9-10.194s-5-.604-5 .307V18.5"
  })));
};
export default SvgSpeechTail;